var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup106(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.063,
    height: 22.039,
    viewBox: "0 0 22.063 22.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3531",
    "data-name": "Path 3531",
    d: "M-500.371,133.921c0,.5-.01.991,0,1.487a.73.73,0,0,1-.265.6,7.635,7.635,0,0,0-1.887,2.616,7.291,7.291,0,0,0,1.614,8.149,7.358,7.358,0,0,0,5.937,2.086,7.308,7.308,0,0,0,6.35-5.55,7.179,7.179,0,0,0-2.352-7.33.619.619,0,0,1-.184-.4c-.015-1.077-.011-2.154-.007-3.232a.454.454,0,0,1,.733-.422,10.812,10.812,0,0,1,5,5.807,11.021,11.021,0,0,1-8.02,14.578,10.969,10.969,0,0,1-12.88-7.672,10.66,10.66,0,0,1,3.314-11.363,17.968,17.968,0,0,1,1.851-1.324.491.491,0,0,1,.793.463C-500.4,132.914-500.371,133.419-500.371,133.921Z",
    transform: "translate(506.797 -130.512)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3532",
    "data-name": "Path 3532",
    d: "M-293.582,106.673q0-2.435,0-4.87c0-.5.13-.623.627-.623h2.5c.394,0,.555.151.555.543q0,4.967,0,9.934c0,.4-.159.553-.568.553h-2.521c-.43,0-.593-.163-.593-.6Q-293.583,109.14-293.582,106.673Z",
    transform: "translate(302.771 -101.179)",
    fill: "#4c5b71"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup106);
export default __webpack_public_path__ + "static/media/Group 106.468564e19bc18f25a8f137e15a111dea.svg";
export { ForwardRef as ReactComponent };